import type { GridInterface } from '@ad-lucy/context/adData';

import { defineGrid } from './defineGrid';

export const grid2x2 = (): GridInterface[] =>
  defineGrid(
    '2:2',
    [
      {
        name: 'Sitebar',
        rows: [
          {
            columns: [
              {
                tileId: 0,
              },
              {
                tileId: 1,
              },
            ],
          },
          {
            columns: [
              {
                tileId: 2,
              },
              {
                tileId: 3,
              },
            ],
          },
        ],
      },
    ],
    2,
    2,
  );
